var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontalWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 908.96368,
    height: 137.28867,
    viewBox: "0 0 908.96367 137.28866",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-286.61301,-410.14191)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-308.14821,-417.09021)",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-359.30031,-390.66871)",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-405.52141,-408.56571)",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-455.29811,-445.61321)",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-510.16561,-408.56571)",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-596.70832,-456.36021)",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-640.10162,-404.52581)",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-685.99982,-463.71291)",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-737.47292,-417.09021)",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-785.31129,-445.61321)",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-833.8759,-406.46511)",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-880.01455,-463.71291)",
    id: "path26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-925.11482,-470.59211)",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-922.53122,-461.40501)",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-402.02661,-383.90951)",
    id: "path36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-417.37921,-385.19881)",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-431.62371,-375.66031)",
    id: "path40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-448.05931,-373.04871)",
    id: "path42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-460.93031,-375.90061)",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-476.65591,-385.19881)",
    id: "path46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-491.14781,-375.82621)",
    id: "path48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-510.64972,-384.53711)",
    id: "path50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-528.98602,-379.01611)",
    id: "path52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-537.12322,-373.91651)",
    id: "path54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-550.58231,-375.67741)",
    id: "path56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-572.82761,-379.01611)",
    id: "path58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-580.89661,-381.49601)",
    id: "path60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-591.02771,-373.48711)",
    id: "path62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-604.18192,-385.19881)",
    id: "path64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-627.19121,-375.67741)",
    id: "path68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-650.50162,-373.91651)",
    id: "path70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-664.39822,-381.49601)",
    id: "path72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-678.71801,-375.67741)",
    id: "path74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-709.26902,-384.53711)",
    id: "path76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-715.26522,-381.49601)",
    id: "path78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-735.55252,-379.01611)",
    id: "path80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-744.84802,-373.08991)",
    id: "path82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-759.20004,-373.04871)",
    id: "path84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-772.60892,-375.82621)",
    id: "path86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-790.12404,-381.49601)",
    id: "path90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-810.36115,-379.01611)",
    id: "path92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-828.23125,-373.20561)",
    id: "path94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-842.80922,-375.66031)",
    id: "path96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-857.97895,-373.91651)",
    id: "path98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-873.09842,-373.08991)",
    id: "path100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-886.2025,-385.19881)",
    id: "path102"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path104"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-908.87462,-381.49601)",
    id: "path106"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-923.19445,-375.90061)",
    id: "path108"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0",
    transform: "translate(-339.21866,-492.61589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 c 2.505,2.154 3.757,5.144 3.757,8.969 0,3.879 -1.279,6.881 -3.838,9.009 -2.558,2.128 -6.154,3.191 -10.787,3.191 h -18.18 V -3.232 h 18.583 c 4.472,0 7.96,1.077 10.465,3.232 m -1.332,27.15 c 2.368,2.046 3.554,4.874 3.554,8.484 0,3.608 -1.171,6.464 -3.515,8.564 -2.343,2.101 -5.616,3.152 -9.817,3.152 H -29.048 V 24.079 h 17.857 c 4.201,0 7.488,1.023 9.859,3.071 m -9.697,23.19 c 2.531,0 4.807,-0.337 6.828,-1.011 2.019,-0.673 3.744,-1.643 5.171,-2.909 1.427,-1.266 2.532,-2.787 3.312,-4.565 0.782,-1.777 1.173,-3.77 1.173,-5.979 0,-3.286 -0.836,-6.06 -2.505,-8.323 -1.67,-2.262 -4.04,-3.852 -7.112,-4.767 3.556,-0.916 6.303,-2.559 8.243,-4.929 1.938,-2.37 2.909,-5.36 2.909,-8.969 0,-4.687 -1.55,-8.377 -4.646,-11.07 -3.099,-2.693 -7.34,-4.04 -12.728,-4.04 H -32.199 V 50.34 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,382.15067,575.66413)",
    clipPath: "url(#clipPath2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 0,0 c 0.916,-2.316 2.197,-4.309 3.839,-5.979 1.643,-1.67 3.61,-2.962 5.898,-3.879 2.289,-0.915 4.809,-1.373 7.556,-1.373 2.747,0 5.264,0.458 7.554,1.373 2.29,0.917 4.255,2.209 5.899,3.879 1.643,1.67 2.921,3.663 3.838,5.979 0.916,2.317 1.373,4.875 1.373,7.676 0,2.802 -0.457,5.361 -1.373,7.677 -0.917,2.316 -2.195,4.296 -3.838,5.938 -1.644,1.644 -3.609,2.923 -5.899,3.839 -2.29,0.916 -4.807,1.373 -7.554,1.373 -2.747,0 -5.267,-0.457 -7.556,-1.373 C 7.449,24.214 5.482,22.935 3.839,21.291 2.197,19.649 0.916,17.669 0,15.353 -0.914,13.037 -1.374,10.478 -1.374,7.676 -1.374,4.875 -0.914,2.317 0,0 m 8.444,-12.564 c -2.667,1.05 -4.955,2.545 -6.868,4.484 -1.911,1.939 -3.394,4.242 -4.443,6.909 -1.051,2.666 -1.576,5.615 -1.576,8.847 0,3.232 0.525,6.182 1.576,8.848 1.049,2.667 2.532,4.97 4.443,6.909 1.913,1.94 4.201,3.434 6.868,4.485 2.666,1.05 5.616,1.575 8.849,1.575 3.231,0 6.181,-0.525 8.847,-1.575 2.666,-1.051 4.956,-2.545 6.868,-4.485 1.913,-1.939 3.394,-4.242 4.445,-6.909 1.051,-2.666 1.576,-5.616 1.576,-8.848 0,-3.232 -0.525,-6.181 -1.576,-8.847 -1.051,-2.667 -2.532,-4.97 -4.445,-6.909 -1.912,-1.939 -4.202,-3.434 -6.868,-4.484 -2.666,-1.051 -5.616,-1.576 -8.847,-1.576 -3.233,0 -6.183,0.525 -8.849,1.576",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,410.86427,566.39973)",
    clipPath: "url(#clipPath4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 0,0 c 1.508,0 2.786,0.094 3.837,0.282 1.051,0.189 1.967,0.553 2.747,1.092 0.782,0.537 1.469,1.252 2.061,2.14 0.593,0.889 1.212,2.061 1.859,3.515 l 2.747,6.707 -19.878,41.209 h 3.394 L 14.786,17.372 30.542,54.945 h 3.233 L 13.251,5.817 C 12.55,4.094 11.809,2.666 11.029,1.535 10.248,0.403 9.358,-0.485 8.363,-1.131 7.366,-1.778 6.22,-2.236 4.927,-2.505 3.635,-2.775 2.073,-2.909 0.242,-2.909 H -3.072 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,479.06707,601.6284)",
    clipPath: "url(#clipPath6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 0,0 c 2.207,-1.696 5.225,-2.545 9.05,-2.545 2.585,0 4.983,0.377 7.19,1.131 2.209,0.754 4.121,1.818 5.738,3.192 1.616,1.373 2.867,2.99 3.757,4.848 0.889,1.858 1.334,3.865 1.334,6.02 v 3.313 H 7.676 C 4.39,15.959 1.738,15.151 -0.283,13.534 -2.304,11.919 -3.314,9.737 -3.314,6.99 -3.314,4.026 -2.209,1.697 0,0 m -2.263,-2.06 c -2.747,2.208 -4.12,5.198 -4.12,8.969 0,3.608 1.278,6.491 3.837,8.645 2.559,2.156 5.939,3.232 10.142,3.232 h 19.473 v 4.04 c 0,1.832 -0.337,3.502 -1.012,5.01 -0.672,1.509 -1.628,2.802 -2.867,3.879 -1.239,1.077 -2.72,1.912 -4.445,2.505 -1.723,0.592 -3.609,0.889 -5.655,0.889 -3.502,0 -6.518,-0.835 -9.05,-2.505 -2.532,-1.67 -4.255,-3.959 -5.171,-6.868 h -3.153 c 1.024,3.824 3.072,6.828 6.142,9.009 3.071,2.181 6.787,3.273 11.151,3.273 2.532,0 4.834,-0.364 6.909,-1.092 2.073,-0.727 3.878,-1.763 5.413,-3.11 1.535,-1.347 2.72,-2.936 3.556,-4.768 0.834,-1.831 1.252,-3.851 1.252,-6.059 V -4.646 H 27.472 L 27.23,3.757 c -1.725,-2.854 -4.189,-5.09 -7.393,-6.706 -3.206,-1.616 -6.828,-2.424 -10.868,-2.424 -4.741,0 -8.485,1.104 -11.232,3.313",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,540.6952,577.76573)",
    clipPath: "url(#clipPath8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 0,0 0.242,-9.777 c 1.454,3.448 3.651,6.101 6.586,7.96 2.935,1.858 6.262,2.787 9.979,2.787 2.693,0 5.117,-0.458 7.273,-1.373 2.153,-0.917 3.998,-2.236 5.533,-3.96 1.537,-1.724 2.708,-3.797 3.517,-6.222 0.806,-2.424 1.212,-5.144 1.212,-8.16 V -41.693 H 31.27 v 22.786 c 0,5.225 -1.332,9.346 -3.999,12.362 -2.666,3.017 -6.263,4.525 -10.787,4.525 -2.37,0 -4.538,-0.43 -6.505,-1.293 C 8.013,-4.174 6.315,-5.387 4.888,-6.948 3.461,-8.511 2.356,-10.37 1.576,-12.524 0.794,-14.678 0.403,-17.076 0.403,-19.715 V -41.693 H -2.666 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,607.06413,528.36907)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 0,0 c 2.207,-1.696 5.225,-2.545 9.05,-2.545 2.585,0 4.983,0.377 7.19,1.131 2.209,0.754 4.121,1.818 5.738,3.192 1.616,1.373 2.867,2.99 3.757,4.848 0.889,1.858 1.334,3.865 1.334,6.02 v 3.313 H 7.676 c -3.287,0 -5.938,-0.808 -7.959,-2.425 C -2.304,11.919 -3.314,9.737 -3.314,6.99 -3.314,4.026 -2.209,1.697 0,0 m -2.263,-2.06 c -2.747,2.208 -4.12,5.198 -4.12,8.969 0,3.608 1.278,6.491 3.837,8.645 2.559,2.156 5.939,3.232 10.142,3.232 h 19.473 v 4.04 c 0,1.832 -0.337,3.502 -1.012,5.01 -0.672,1.509 -1.628,2.802 -2.867,3.879 -1.239,1.077 -2.72,1.912 -4.445,2.505 -1.723,0.592 -3.609,0.889 -5.655,0.889 -3.502,0 -6.518,-0.835 -9.05,-2.505 -2.532,-1.67 -4.255,-3.959 -5.171,-6.868 h -3.153 c 1.024,3.824 3.072,6.828 6.142,9.009 3.069,2.181 6.787,3.273 11.151,3.273 2.532,0 4.834,-0.364 6.909,-1.092 2.073,-0.727 3.878,-1.763 5.413,-3.11 1.535,-1.347 2.72,-2.936 3.556,-4.768 0.834,-1.831 1.252,-3.851 1.252,-6.059 V -4.646 H 27.472 L 27.23,3.757 c -1.725,-2.854 -4.189,-5.09 -7.393,-6.706 -3.206,-1.616 -6.828,-2.424 -10.868,-2.424 -4.741,0 -8.485,1.104 -11.232,3.313",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,680.2208,577.76573)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 0,0 -14.14,-34.179 H 14.221 Z M 1.616,4.121 25.211,-52.44 h -3.394 l -6.384,15.272 h -30.786 l -6.383,-15.272 h -3.393 L -1.535,4.121 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,795.61107,514.03973)",
    clipPath: "url(#clipPath14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 0,0 c -2.586,1.051 -4.809,2.545 -6.667,4.485 -1.857,1.939 -3.299,4.241 -4.323,6.908 -1.024,2.667 -1.535,5.616 -1.535,8.848 0,3.232 0.511,6.181 1.535,8.848 1.024,2.666 2.466,4.956 4.323,6.868 1.858,1.913 4.081,3.407 6.667,4.485 2.586,1.077 5.44,1.615 8.564,1.615 4.848,0 9.077,-1.279 12.686,-3.838 3.61,-2.559 6.115,-6.019 7.515,-10.383 h -3.152 c -1.508,3.61 -3.73,6.384 -6.665,8.323 -2.935,1.939 -6.398,2.908 -10.384,2.908 -2.693,0 -5.145,-0.457 -7.352,-1.373 -2.209,-0.915 -4.108,-2.195 -5.697,-3.838 -1.59,-1.643 -2.815,-3.622 -3.677,-5.939 -0.861,-2.316 -1.293,-4.875 -1.293,-7.676 0,-2.801 0.432,-5.36 1.293,-7.677 C -7.3,10.249 -6.075,8.255 -4.485,6.585 -2.896,4.916 -0.997,3.623 1.212,2.707 3.419,1.791 5.871,1.333 8.564,1.333 c 4.203,0 7.825,1.078 10.868,3.232 3.045,2.155 5.186,5.091 6.425,8.808 h 3.231 C 27.687,8.632 25.182,4.956 21.573,2.344 17.965,-0.269 13.628,-1.576 8.564,-1.576 5.44,-1.576 2.586,-1.051 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,853.4688,583.15227)",
    clipPath: "url(#clipPath16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 0,0 v -27.553 c 1.508,3.34 3.717,5.912 6.626,7.717 2.91,1.804 6.222,2.706 9.939,2.706 2.693,0 5.117,-0.458 7.273,-1.373 2.153,-0.916 3.971,-2.223 5.452,-3.919 1.483,-1.697 2.627,-3.757 3.436,-6.182 0.807,-2.424 1.212,-5.144 1.212,-8.16 v -23.029 h -3.071 v 22.867 c 0,5.279 -1.293,9.4 -3.879,12.362 -2.586,2.963 -6.168,4.444 -10.746,4.444 -2.37,0 -4.553,-0.416 -6.545,-1.252 -1.994,-0.835 -3.704,-2.02 -5.132,-3.555 C 3.138,-26.462 2.021,-28.32 1.212,-30.503 0.405,-32.684 0,-35.095 0,-37.734 V -59.793 H -3.07 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,914.6664,504.23613)",
    clipPath: "url(#clipPath18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 0,0 c 0.916,-2.316 2.197,-4.309 3.839,-5.979 1.643,-1.67 3.61,-2.962 5.898,-3.879 2.289,-0.915 4.809,-1.373 7.556,-1.373 2.747,0 5.264,0.458 7.554,1.373 2.29,0.917 4.255,2.209 5.899,3.879 1.643,1.67 2.921,3.663 3.838,5.979 0.916,2.317 1.373,4.875 1.373,7.676 0,2.802 -0.457,5.361 -1.373,7.677 -0.917,2.316 -2.195,4.296 -3.838,5.938 -1.644,1.644 -3.609,2.923 -5.899,3.839 -2.29,0.916 -4.807,1.373 -7.554,1.373 -2.747,0 -5.267,-0.457 -7.556,-1.373 C 7.449,24.214 5.482,22.935 3.839,21.291 2.197,19.649 0.916,17.669 0,15.353 -0.914,13.037 -1.374,10.478 -1.374,7.676 -1.374,4.875 -0.914,2.317 0,0 m 8.444,-12.564 c -2.667,1.05 -4.955,2.545 -6.868,4.484 -1.911,1.939 -3.394,4.242 -4.443,6.909 -1.051,2.666 -1.576,5.615 -1.576,8.847 0,3.232 0.525,6.182 1.576,8.848 1.049,2.667 2.532,4.97 4.443,6.909 1.913,1.94 4.201,3.434 6.868,4.485 2.666,1.05 5.616,1.575 8.849,1.575 3.231,0 6.181,-0.525 8.847,-1.575 2.666,-1.051 4.956,-2.545 6.868,-4.485 1.913,-1.939 3.394,-4.242 4.445,-6.909 1.051,-2.666 1.576,-5.616 1.576,-8.848 0,-3.232 -0.525,-6.181 -1.576,-8.847 -1.051,-2.667 -2.532,-4.97 -4.445,-6.909 -1.912,-1.939 -4.202,-3.434 -6.868,-4.484 -2.666,-1.051 -5.616,-1.576 -8.847,-1.576 -3.233,0 -6.183,0.525 -8.849,1.576",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,983.2972,566.39973)",
    clipPath: "url(#clipPath20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M 0,0 17.13,-37.734 25.776,-18.422 34.261,0 h 3.312 L 18.584,-41.693 H 15.595 L -3.314,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1047.0817,528.36907)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 0,0 c -2.962,2.344 -4.578,5.562 -4.849,9.656 h 2.991 C -1.589,6.37 -0.256,3.825 2.141,2.02 4.538,0.215 7.918,-0.687 12.283,-0.687 c 4.04,0 7.217,0.754 9.534,2.262 2.316,1.509 3.475,3.556 3.475,6.142 0,2.424 -1.092,4.404 -3.273,5.938 -2.182,1.535 -5.669,2.707 -10.464,3.515 -5.387,0.97 -9.333,2.411 -11.838,4.323 -2.505,1.912 -3.757,4.431 -3.757,7.555 0,3.394 1.374,6.087 4.121,8.08 2.747,1.993 6.518,2.99 11.312,2.99 4.795,0 8.606,-1.064 11.433,-3.192 2.828,-2.127 4.404,-5.184 4.727,-9.17 h -2.989 c -0.269,3.124 -1.549,5.494 -3.837,7.11 -2.29,1.616 -5.401,2.424 -9.334,2.424 -3.878,0 -6.921,-0.741 -9.13,-2.222 -2.209,-1.481 -3.314,-3.515 -3.314,-6.1 0,-2.317 1.065,-4.189 3.192,-5.616 2.128,-1.428 5.616,-2.599 10.465,-3.515 10.504,-1.993 15.756,-6.034 15.756,-12.12 0,-3.448 -1.442,-6.182 -4.324,-8.202 -2.881,-2.02 -6.801,-3.03 -11.755,-3.03 C 7.058,-3.515 2.962,-2.344 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1111.8345,580.56653)",
    clipPath: "url(#clipPath24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 0,0 v -37.088 h 6.869 c 2.1,0 3.933,0.148 5.495,0.445 1.561,0.296 2.908,0.808 4.039,1.535 1.132,0.727 2.129,1.697 2.99,2.909 0.862,1.212 1.671,2.734 2.424,4.565 l 3.798,9.534 h 3.233 l -4.203,-10.746 c -0.915,-2.37 -1.98,-4.296 -3.192,-5.777 -1.212,-1.481 -2.652,-2.653 -4.322,-3.515 l 13.816,-21.655 h -3.636 l -13.09,20.605 c -1.992,-0.539 -4.497,-0.808 -7.513,-0.808 H 0 V -59.793 H -3.07 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1173.3527,504.23613)",
    clipPath: "url(#clipPath26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 926.56,403.92 h -3.07 v 41.693 h 3.07 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1122.52)",
    clipPath: "url(#clipPath28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 0,0 c -5.066,0 -9.188,-4.121 -9.188,-9.187 0,-5.066 4.122,-9.187 9.188,-9.187 5.066,0 9.186,4.121 9.186,9.187 C 9.186,-4.121 5.066,0 0,0 m 0,-20.21 c -6.079,0 -11.024,4.945 -11.024,11.023 0,6.078 4.945,11.023 11.024,11.023 6.077,0 11.022,-4.945 11.022,-11.023 C 11.022,-15.265 6.077,-20.21 0,-20.21",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1233.4864,495.06387)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "M 0,0 C 0,1.427 1.157,2.583 2.583,2.583 4.01,2.583 5.167,1.427 5.167,0 5.167,-1.427 4.01,-2.583 2.583,-2.583 1.157,-2.583 0,-1.427 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1230.0416,507.31333)",
    clipPath: "url(#clipPath34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M 0,0 V 0.628 H 8.747 V 0 H 4.694 V -10.943 H 4.052 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,536.03547,610.64067)",
    clipPath: "url(#clipPath36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 0,0 v -5.637 c 0.308,0.684 0.76,1.21 1.356,1.578 0.595,0.37 1.273,0.554 2.033,0.554 0.552,0 1.047,-0.093 1.488,-0.28 0.441,-0.188 0.811,-0.455 1.116,-0.803 0.301,-0.347 0.538,-0.768 0.702,-1.264 0.165,-0.496 0.248,-1.052 0.248,-1.669 v -4.712 H 6.315 v 4.679 c 0,1.079 -0.265,1.923 -0.792,2.529 -0.531,0.606 -1.263,0.909 -2.199,0.909 -0.487,0 -0.932,-0.085 -1.341,-0.256 C 1.574,-4.544 1.226,-4.786 0.932,-5.1 0.642,-5.414 0.412,-5.794 0.247,-6.24 0.082,-6.687 0,-7.18 0,-7.72 v -4.513 H -0.628 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,556.5056,608.9216)",
    clipPath: "url(#clipPath38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 0,0 c 0.186,-0.473 0.448,-0.881 0.785,-1.223 0.337,-0.341 0.739,-0.606 1.209,-0.793 0.466,-0.188 0.983,-0.282 1.546,-0.282 0.559,0 1.075,0.094 1.545,0.282 0.466,0.187 0.868,0.452 1.205,0.793 0.337,0.342 0.599,0.75 0.786,1.223 0.186,0.474 0.279,0.998 0.279,1.571 0,0.573 -0.093,1.096 -0.279,1.57 C 6.889,3.615 6.627,4.02 6.29,4.356 5.953,4.692 5.551,4.953 5.085,5.141 4.615,5.328 4.099,5.422 3.54,5.422 2.977,5.422 2.46,5.328 1.994,5.141 1.524,4.953 1.122,4.692 0.785,4.356 0.448,4.02 0.186,3.615 0,3.141 -0.186,2.667 -0.28,2.144 -0.28,1.571 -0.28,0.998 -0.186,0.474 0,0 m 1.729,-2.57 c -0.546,0.215 -1.015,0.52 -1.406,0.918 -0.391,0.396 -0.696,0.868 -0.908,1.413 -0.215,0.545 -0.322,1.148 -0.322,1.81 0,0.661 0.107,1.264 0.322,1.81 0.212,0.545 0.517,1.017 0.908,1.413 0.391,0.397 0.86,0.703 1.406,0.917 0.545,0.215 1.147,0.323 1.811,0.323 0.659,0 1.262,-0.108 1.807,-0.323 C 5.892,5.497 6.362,5.191 6.753,4.794 7.144,4.398 7.449,3.926 7.664,3.381 7.879,2.835 7.983,2.232 7.983,1.571 7.983,0.909 7.879,0.306 7.664,-0.239 7.449,-0.784 7.144,-1.256 6.753,-1.652 6.362,-2.05 5.892,-2.355 5.347,-2.57 4.802,-2.785 4.199,-2.892 3.54,-2.892 c -0.664,0 -1.266,0.107 -1.811,0.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,575.49827,621.6396)",
    clipPath: "url(#clipPath40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "M 0,0 C -0.434,0.187 -0.807,0.457 -1.115,0.81 -1.424,1.163 -1.66,1.587 -1.825,2.083 -1.99,2.578 -2.073,3.13 -2.073,3.736 v 4.711 h 0.628 V 3.785 c 0,-1.068 0.262,-1.914 0.792,-2.537 0.527,-0.622 1.256,-0.934 2.181,-0.934 0.487,0 0.929,0.089 1.323,0.265 0.398,0.176 0.735,0.424 1.019,0.743 0.279,0.32 0.498,0.703 0.659,1.15 C 4.691,2.917 4.77,3.41 4.77,3.951 V 8.447 H 5.397 V -0.082 H 4.852 L 4.784,1.901 C 4.486,1.207 4.049,0.67 3.464,0.29 2.88,-0.091 2.213,-0.281 1.463,-0.281 0.922,-0.281 0.434,-0.187 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,597.4124,625.12173)",
    clipPath: "url(#clipPath42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 0,0 c 0.183,-0.457 0.437,-0.849 0.76,-1.174 0.327,-0.325 0.718,-0.579 1.177,-0.761 0.455,-0.181 0.954,-0.272 1.495,-0.272 0.549,0 1.051,0.091 1.503,0.272 0.452,0.182 0.842,0.436 1.165,0.761 0.327,0.325 0.581,0.713 0.76,1.165 C 7.043,0.443 7.133,0.945 7.133,1.495 7.133,2.047 7.043,2.548 6.86,3 6.681,3.452 6.427,3.837 6.1,4.157 5.777,4.477 5.387,4.728 4.935,4.91 4.483,5.091 3.981,5.182 3.432,5.182 2.88,5.182 2.378,5.091 1.926,4.91 1.474,4.728 1.087,4.477 0.76,4.157 0.437,3.837 0.183,3.452 0,3 -0.179,2.548 -0.273,2.047 -0.273,1.495 -0.273,0.956 -0.179,0.457 0,0 m 2.152,-6.249 c -0.449,0.127 -0.843,0.308 -1.184,0.546 -0.34,0.237 -0.624,0.524 -0.85,0.859 -0.226,0.336 -0.383,0.708 -0.473,1.116 h 0.628 c 0.078,-0.319 0.215,-0.611 0.405,-0.876 0.193,-0.264 0.437,-0.488 0.728,-0.67 0.294,-0.182 0.62,-0.321 0.982,-0.421 0.366,-0.099 0.761,-0.149 1.191,-0.149 0.531,0 1.008,0.075 1.438,0.224 0.43,0.148 0.796,0.36 1.101,0.636 0.301,0.275 0.538,0.609 0.71,1 0.172,0.392 0.255,0.824 0.255,1.298 v 1.917 C 6.731,-1.408 6.236,-1.91 5.598,-2.273 4.956,-2.637 4.221,-2.819 3.382,-2.819 c -0.628,0 -1.209,0.108 -1.736,0.323 -0.531,0.214 -0.983,0.512 -1.356,0.892 -0.372,0.38 -0.667,0.835 -0.875,1.364 -0.211,0.529 -0.315,1.108 -0.315,1.735 0,0.629 0.104,1.207 0.315,1.736 0.208,0.529 0.503,0.984 0.875,1.364 0.373,0.38 0.825,0.675 1.356,0.885 0.527,0.209 1.108,0.314 1.736,0.314 0.85,0 1.596,-0.185 2.241,-0.555 C 6.265,4.871 6.764,4.361 7.119,3.711 l 0.05,1.884 h 0.545 v -8.298 c 0,-0.551 -0.1,-1.055 -0.298,-1.513 -0.201,-0.457 -0.48,-0.85 -0.842,-1.181 -0.366,-0.331 -0.8,-0.587 -1.309,-0.77 -0.506,-0.181 -1.069,-0.272 -1.686,-0.272 -0.506,0 -0.983,0.064 -1.427,0.19",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,614.57373,621.3192)",
    clipPath: "url(#clipPath44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "m 0,0 v -5.637 c 0.308,0.684 0.76,1.21 1.356,1.578 0.595,0.37 1.273,0.554 2.033,0.554 0.552,0 1.047,-0.093 1.488,-0.28 0.441,-0.188 0.811,-0.455 1.116,-0.803 0.301,-0.347 0.538,-0.768 0.702,-1.264 0.165,-0.496 0.248,-1.052 0.248,-1.669 v -4.712 H 6.315 v 4.679 c 0,1.079 -0.265,1.923 -0.792,2.529 -0.531,0.606 -1.263,0.909 -2.199,0.909 -0.487,0 -0.932,-0.085 -1.341,-0.256 C 1.574,-4.544 1.226,-4.786 0.932,-5.1 0.642,-5.414 0.412,-5.794 0.247,-6.24 0.082,-6.687 0,-7.18 0,-7.72 v -4.513 H -0.628 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,635.5412,608.9216)",
    clipPath: "url(#clipPath46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M 0,0 V 5.074 H -1.933 V 5.67 h 1.287 c 0.266,0 0.445,0.044 0.538,0.132 0.094,0.088 0.151,0.259 0.176,0.512 L 0.1,7.719 H 0.628 V 5.67 H 3.719 V 5.074 H 0.628 V 0.016 c 0,-0.771 0.161,-1.341 0.48,-1.71 0.319,-0.37 0.839,-0.555 1.553,-0.555 H 3.852 V -2.86 H 2.647 C 0.882,-2.86 0,-1.907 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,654.86373,621.4184)",
    clipPath: "url(#clipPath48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 0,0 v -10.942 h 6.064 v -0.629 h -6.71 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,680.86627,609.80387)",
    clipPath: "url(#clipPath50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "M 0,0 C -0.194,0.441 -0.448,0.816 -0.771,1.124 -1.09,1.433 -1.467,1.669 -1.901,1.835 -2.338,2 -2.819,2.083 -3.349,2.083 -3.877,2.083 -4.364,1.998 -4.813,1.826 -5.257,1.656 -5.645,1.414 -5.967,1.099 -6.294,0.785 -6.552,0.411 -6.746,-0.025 -6.939,-0.46 -7.05,-0.948 -7.083,-1.487 H 0.355 C 0.312,-0.937 0.194,-0.441 0,0 m -5.125,-5.926 c -0.534,0.215 -0.993,0.521 -1.373,0.918 -0.38,0.396 -0.674,0.868 -0.882,1.413 -0.212,0.545 -0.316,1.148 -0.316,1.81 0,0.661 0.104,1.267 0.316,1.818 0.208,0.552 0.502,1.022 0.882,1.413 0.38,0.392 0.839,0.695 1.373,0.909 0.535,0.215 1.126,0.323 1.776,0.323 0.663,0 1.258,-0.113 1.796,-0.339 0.535,-0.226 0.99,-0.548 1.37,-0.967 0.38,-0.419 0.674,-0.917 0.875,-1.496 0.205,-0.578 0.309,-1.226 0.309,-1.943 h -8.084 c 0.033,-0.539 0.144,-1.03 0.337,-1.471 0.194,-0.44 0.449,-0.817 0.771,-1.131 0.32,-0.315 0.7,-0.557 1.148,-0.728 0.445,-0.171 0.932,-0.257 1.463,-0.257 0.793,0 1.481,0.177 2.066,0.529 0.584,0.354 1.018,0.844 1.305,1.472 h 0.71 c -0.33,-0.815 -0.85,-1.452 -1.56,-1.909 -0.71,-0.457 -1.553,-0.686 -2.521,-0.686 -0.638,0 -1.226,0.107 -1.761,0.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,705.31467,617.1652)",
    clipPath: "url(#clipPath52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 0,0 c 0.452,-0.347 1.069,-0.521 1.851,-0.521 0.527,0 1.018,0.077 1.47,0.232 0.452,0.155 0.843,0.371 1.173,0.653 0.333,0.281 0.588,0.611 0.771,0.992 0.179,0.38 0.272,0.79 0.272,1.231 V 3.265 H 1.571 C 0.897,3.265 0.355,3.099 -0.057,2.769 -0.473,2.439 -0.678,1.992 -0.678,1.43 -0.678,0.824 -0.452,0.347 0,0 m -0.463,-0.421 c -0.563,0.451 -0.842,1.063 -0.842,1.835 0,0.738 0.261,1.328 0.785,1.768 C 0,3.623 0.692,3.844 1.553,3.844 H 5.537 V 4.67 C 5.537,5.045 5.469,5.387 5.329,5.695 5.193,6.003 4.996,6.268 4.745,6.488 4.49,6.709 4.185,6.879 3.834,7 3.482,7.122 3.095,7.182 2.675,7.182 1.962,7.182 1.345,7.012 0.825,6.67 0.308,6.329 -0.047,5.86 -0.233,5.265 h -0.646 c 0.212,0.782 0.632,1.396 1.259,1.843 0.628,0.446 1.388,0.67 2.281,0.67 0.516,0 0.99,-0.075 1.413,-0.224 C 4.497,7.406 4.867,7.194 5.182,6.918 5.494,6.643 5.738,6.317 5.91,5.942 6.079,5.569 6.165,5.155 6.165,4.703 V -0.95 H 5.62 L 5.569,0.769 C 5.218,0.185 4.712,-0.273 4.056,-0.603 3.4,-0.934 2.661,-1.099 1.833,-1.099 c -0.969,0 -1.736,0.226 -2.296,0.678",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,716.16427,623.96467)",
    clipPath: "url(#clipPath54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 0,0 c 0.183,-0.474 0.441,-0.882 0.775,-1.224 0.337,-0.341 0.738,-0.609 1.208,-0.801 0.47,-0.193 0.99,-0.29 1.564,-0.29 0.559,0 1.076,0.097 1.545,0.29 0.467,0.192 0.868,0.46 1.205,0.801 0.338,0.342 0.599,0.75 0.786,1.224 0.186,0.473 0.279,0.992 0.279,1.554 0,0.562 -0.093,1.079 -0.279,1.553 C 6.896,3.582 6.635,3.989 6.297,4.33 5.96,4.672 5.559,4.936 5.092,5.124 4.623,5.311 4.106,5.405 3.547,5.405 2.973,5.405 2.453,5.311 1.983,5.124 1.513,4.936 1.112,4.672 0.775,4.33 0.441,3.989 0.183,3.582 0,3.107 -0.183,2.633 -0.273,2.116 -0.273,1.554 -0.273,0.992 -0.183,0.473 0,0 M 1.686,-2.578 C 1.151,-2.359 0.692,-2.05 0.305,-1.653 -0.079,-1.257 -0.377,-0.785 -0.588,-0.24 -0.796,0.306 -0.9,0.904 -0.9,1.554 c 0,0.65 0.104,1.248 0.312,1.793 0.211,0.546 0.509,1.017 0.893,1.414 C 0.692,5.157 1.151,5.465 1.686,5.686 2.22,5.907 2.819,6.017 3.479,6.017 4.372,6.017 5.15,5.816 5.817,5.413 6.484,5.011 6.993,4.468 7.348,3.785 V 9.521 H 7.976 V -2.711 H 7.431 L 7.38,-0.628 C 7.029,-1.334 6.516,-1.89 5.842,-2.298 5.171,-2.706 4.382,-2.909 3.479,-2.909 c -0.66,0 -1.259,0.11 -1.793,0.331",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,734.10973,621.6168)",
    clipPath: "url(#clipPath56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "M 0,0 C -0.194,0.441 -0.448,0.816 -0.771,1.124 -1.09,1.433 -1.467,1.669 -1.901,1.835 -2.338,2 -2.819,2.083 -3.35,2.083 -3.877,2.083 -4.364,1.998 -4.813,1.826 -5.257,1.656 -5.645,1.414 -5.967,1.099 -6.294,0.785 -6.552,0.411 -6.746,-0.025 -6.939,-0.46 -7.051,-0.948 -7.083,-1.487 H 0.355 C 0.312,-0.937 0.194,-0.441 0,0 m -5.125,-5.926 c -0.534,0.215 -0.993,0.521 -1.373,0.918 -0.38,0.396 -0.674,0.868 -0.882,1.413 -0.212,0.545 -0.316,1.148 -0.316,1.81 0,0.661 0.104,1.267 0.316,1.818 0.208,0.552 0.502,1.022 0.882,1.413 0.38,0.392 0.839,0.695 1.373,0.909 0.535,0.215 1.126,0.323 1.775,0.323 0.664,0 1.259,-0.113 1.797,-0.339 0.535,-0.226 0.99,-0.548 1.37,-0.967 0.38,-0.419 0.674,-0.917 0.875,-1.496 0.205,-0.578 0.309,-1.226 0.309,-1.943 h -8.084 c 0.032,-0.539 0.144,-1.03 0.337,-1.471 0.194,-0.44 0.449,-0.817 0.771,-1.131 0.319,-0.315 0.7,-0.557 1.148,-0.728 0.445,-0.171 0.932,-0.257 1.463,-0.257 0.793,0 1.481,0.177 2.066,0.529 0.584,0.354 1.018,0.844 1.305,1.472 h 0.71 c -0.33,-0.815 -0.85,-1.452 -1.56,-1.909 -0.71,-0.457 -1.553,-0.686 -2.521,-0.686 -0.638,0 -1.226,0.107 -1.761,0.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,763.77013,617.1652)",
    clipPath: "url(#clipPath58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 0,0 0.05,-2.298 c 0.276,0.76 0.685,1.333 1.223,1.719 C 1.815,-0.193 2.514,0 3.375,0 H 4.02 V -0.595 H 3.342 C 2.317,-0.595 1.517,-0.926 0.943,-1.587 0.369,-2.249 0.086,-3.263 0.086,-4.629 V -8.53 H -0.545 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,774.5288,613.85867)",
    clipPath: "url(#clipPath60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 0,0 c -0.606,0.479 -0.936,1.138 -0.993,1.975 h 0.613 c 0.054,-0.672 0.326,-1.192 0.817,-1.562 0.492,-0.369 1.184,-0.554 2.077,-0.554 0.825,0 1.474,0.154 1.947,0.463 0.477,0.308 0.714,0.728 0.714,1.257 0,0.496 -0.226,0.9 -0.671,1.215 C 4.06,3.107 3.346,3.347 2.363,3.513 1.262,3.711 0.455,4.006 -0.057,4.397 -0.57,4.789 -0.828,5.303 -0.828,5.942 c 0,0.694 0.283,1.246 0.846,1.654 0.559,0.408 1.33,0.611 2.313,0.611 0.979,0 1.761,-0.218 2.338,-0.653 0.578,-0.435 0.9,-1.06 0.969,-1.876 H 5.024 C 4.97,6.317 4.709,6.802 4.239,7.133 3.773,7.463 3.134,7.629 2.331,7.629 1.538,7.629 0.914,7.477 0.463,7.174 0.011,6.871 -0.215,6.455 -0.215,5.926 -0.215,5.452 0.004,5.069 0.437,4.777 0.871,4.485 1.585,4.245 2.578,4.058 4.727,3.65 5.802,2.824 5.802,1.579 5.802,0.873 5.508,0.314 4.917,-0.1 4.329,-0.513 3.525,-0.719 2.514,-0.719 1.445,-0.719 0.606,-0.48 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,788.03693,624.5372)",
    clipPath: "url(#clipPath62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 0,0 v -5.637 c 0.308,0.684 0.76,1.21 1.356,1.578 0.595,0.37 1.273,0.554 2.033,0.554 0.552,0 1.047,-0.093 1.488,-0.28 0.441,-0.188 0.811,-0.455 1.116,-0.803 0.301,-0.347 0.538,-0.768 0.702,-1.264 0.165,-0.496 0.248,-1.052 0.248,-1.669 v -4.712 H 6.315 v 4.679 c 0,1.079 -0.265,1.923 -0.792,2.529 -0.531,0.606 -1.263,0.909 -2.199,0.909 -0.487,0 -0.932,-0.085 -1.341,-0.256 C 1.574,-4.544 1.227,-4.786 0.932,-5.1 0.642,-5.414 0.412,-5.794 0.247,-6.24 0.083,-6.687 0,-7.18 0,-7.72 v -4.513 H -0.628 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,805.57587,608.9216)",
    clipPath: "url(#clipPath64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 618.939,372.966 h -0.628 v 8.53 h 0.628 z m -0.817,11.373 c 0.125,0.132 0.294,0.198 0.502,0.198 0.211,0 0.38,-0.066 0.505,-0.198 0.126,-0.132 0.19,-0.298 0.19,-0.496 0,-0.187 -0.064,-0.347 -0.19,-0.479 -0.125,-0.132 -0.294,-0.199 -0.505,-0.199 -0.208,0 -0.377,0.067 -0.502,0.199 -0.126,0.132 -0.19,0.292 -0.19,0.479 0,0.198 0.064,0.364 0.19,0.496",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1122.52)",
    clipPath: "url(#clipPath66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "m 0,0 c 0.183,-0.474 0.441,-0.882 0.778,-1.224 0.337,-0.341 0.739,-0.609 1.209,-0.801 0.466,-0.193 0.986,-0.29 1.56,-0.29 0.574,0 1.094,0.097 1.563,0.29 0.467,0.192 0.872,0.46 1.205,0.801 0.337,0.342 0.596,0.75 0.779,1.224 0.182,0.473 0.272,0.992 0.272,1.554 0,0.562 -0.09,1.079 -0.272,1.553 C 6.911,3.582 6.652,3.989 6.315,4.33 5.982,4.672 5.577,4.936 5.11,5.124 4.641,5.311 4.121,5.405 3.547,5.405 2.973,5.405 2.453,5.311 1.987,5.124 1.517,4.936 1.115,4.672 0.778,4.33 0.441,3.989 0.183,3.582 0,3.107 -0.179,2.633 -0.273,2.116 -0.273,1.554 -0.273,0.992 -0.179,0.473 0,0 m 1.266,-2.323 c -0.66,0.392 -1.169,0.929 -1.521,1.612 V -6.018 H -0.882 V 5.819 h 0.545 l 0.05,-2.067 c 0.352,0.694 0.861,1.245 1.528,1.653 0.667,0.408 1.452,0.612 2.356,0.612 0.66,0 1.262,-0.11 1.8,-0.331 C 5.939,5.465 6.401,5.157 6.789,4.761 7.172,4.364 7.47,3.893 7.682,3.347 7.89,2.802 7.994,2.204 7.994,1.554 7.994,0.904 7.89,0.306 7.682,-0.24 7.47,-0.785 7.172,-1.257 6.789,-1.653 6.401,-2.05 5.939,-2.359 5.397,-2.578 c -0.538,-0.221 -1.14,-0.331 -1.8,-0.331 -0.893,0 -1.671,0.195 -2.331,0.586",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,836.25493,621.6168)",
    clipPath: "url(#clipPath68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 0,0 c 0.452,-0.347 1.069,-0.521 1.851,-0.521 0.53,0 1.022,0.077 1.473,0.232 0.452,0.155 0.843,0.371 1.173,0.653 0.33,0.281 0.588,0.611 0.768,0.992 0.183,0.38 0.272,0.79 0.272,1.231 V 3.265 H 1.571 C 0.9,3.265 0.355,3.099 -0.057,2.769 -0.47,2.439 -0.678,1.992 -0.678,1.43 -0.678,0.824 -0.452,0.347 0,0 m -0.463,-0.421 c -0.563,0.451 -0.842,1.063 -0.842,1.835 0,0.738 0.261,1.328 0.785,1.768 0.524,0.441 1.216,0.662 2.073,0.662 H 5.537 V 4.67 C 5.537,5.045 5.469,5.387 5.333,5.695 5.193,6.003 4.999,6.268 4.745,6.488 4.49,6.709 4.189,6.879 3.837,7 3.482,7.122 3.099,7.182 2.679,7.182 1.962,7.182 1.345,7.012 0.828,6.67 0.308,6.329 -0.043,5.86 -0.229,5.265 h -0.646 c 0.208,0.782 0.628,1.396 1.255,1.843 0.628,0.446 1.388,0.67 2.281,0.67 0.52,0 0.99,-0.075 1.413,-0.224 C 4.501,7.406 4.87,7.194 5.182,6.918 5.498,6.643 5.738,6.317 5.91,5.942 6.082,5.569 6.165,5.155 6.165,4.703 V -0.95 H 5.62 L 5.573,0.769 C 5.218,0.185 4.716,-0.273 4.06,-0.603 3.403,-0.934 2.661,-1.099 1.836,-1.099 c -0.972,0 -1.736,0.226 -2.299,0.678",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,867.33547,623.96467)",
    clipPath: "url(#clipPath70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 0,0 0.05,-2 c 0.298,0.704 0.75,1.248 1.349,1.628 0.599,0.38 1.28,0.57 2.04,0.57 0.553,0 1.047,-0.093 1.488,-0.28 0.442,-0.188 0.818,-0.459 1.134,-0.811 0.312,-0.352 0.552,-0.776 0.717,-1.273 0.165,-0.496 0.247,-1.052 0.247,-1.669 V -8.53 H 6.398 v 4.661 c 0,1.07 -0.273,1.913 -0.818,2.53 -0.545,0.617 -1.28,0.926 -2.205,0.926 -0.484,0 -0.929,-0.089 -1.331,-0.265 C 1.643,-0.854 1.295,-1.102 1.001,-1.422 0.71,-1.741 0.484,-2.121 0.323,-2.562 0.165,-3.003 0.086,-3.494 0.086,-4.034 V -8.53 H -0.545 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,885.86427,613.85867)",
    clipPath: "url(#clipPath72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m 0,0 c 0.183,-0.474 0.441,-0.882 0.778,-1.224 0.337,-0.341 0.739,-0.609 1.209,-0.801 0.47,-0.193 0.99,-0.29 1.564,-0.29 0.563,0 1.076,0.097 1.545,0.29 0.47,0.192 0.872,0.46 1.209,0.801 0.334,0.342 0.595,0.75 0.782,1.224 0.19,0.473 0.283,0.992 0.283,1.554 0,0.562 -0.093,1.079 -0.283,1.553 C 6.896,3.582 6.635,3.989 6.301,4.33 5.964,4.672 5.562,4.936 5.092,5.124 4.623,5.311 4.11,5.405 3.547,5.405 2.973,5.405 2.453,5.311 1.983,5.124 1.517,4.936 1.115,4.672 0.778,4.33 0.441,3.989 0.183,3.582 0,3.107 -0.179,2.633 -0.273,2.116 -0.273,1.554 -0.273,0.992 -0.179,0.473 0,0 M 1.689,-2.578 C 1.151,-2.359 0.692,-2.05 0.308,-1.653 -0.079,-1.257 -0.377,-0.785 -0.585,-0.24 -0.796,0.306 -0.9,0.904 -0.9,1.554 c 0,0.65 0.104,1.248 0.315,1.793 0.208,0.546 0.506,1.017 0.893,1.414 0.384,0.396 0.843,0.704 1.381,0.925 0.534,0.221 1.13,0.331 1.793,0.331 0.893,0 1.671,-0.201 2.338,-0.604 C 6.487,5.011 6.997,4.468 7.348,3.785 V 9.521 H 7.976 V -2.711 H 7.431 L 7.38,-0.628 C 7.029,-1.334 6.516,-1.89 5.846,-2.298 5.171,-2.706 4.386,-2.909 3.482,-2.909 c -0.663,0 -1.259,0.11 -1.793,0.331",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,904.95733,621.6168)",
    clipPath: "url(#clipPath74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m 0,0 v -0.611 h -5.985 v -4.761 h 5.555 v -0.612 h -5.555 v -4.976 h 6.182 v -0.611 H -6.627 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,945.692,609.80387)",
    clipPath: "url(#clipPath76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "M 0,0 H 0.76 L 2.808,-2.612 3.619,-3.687 4.429,-2.612 6.462,0 H 7.223 L 4.031,-4.133 7.47,-8.53 H 6.692 L 3.619,-4.579 0.527,-8.53 h -0.76 l 3.421,4.397 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,953.68693,613.85867)",
    clipPath: "url(#clipPath78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "M 0,0 C -0.194,0.441 -0.448,0.816 -0.771,1.124 -1.09,1.433 -1.467,1.669 -1.901,1.835 -2.338,2 -2.819,2.083 -3.35,2.083 -3.877,2.083 -4.364,1.998 -4.813,1.826 -5.257,1.656 -5.645,1.414 -5.967,1.099 -6.294,0.785 -6.552,0.411 -6.746,-0.025 -6.939,-0.46 -7.051,-0.948 -7.083,-1.487 H 0.355 C 0.312,-0.937 0.194,-0.441 0,0 m -5.125,-5.926 c -0.534,0.215 -0.993,0.521 -1.373,0.918 -0.38,0.396 -0.674,0.868 -0.882,1.413 -0.212,0.545 -0.316,1.148 -0.316,1.81 0,0.661 0.104,1.267 0.316,1.818 0.208,0.552 0.502,1.022 0.882,1.413 0.38,0.392 0.839,0.695 1.373,0.909 0.535,0.215 1.126,0.323 1.775,0.323 0.664,0 1.259,-0.113 1.797,-0.339 0.535,-0.226 0.99,-0.548 1.37,-0.967 0.38,-0.419 0.674,-0.917 0.875,-1.496 0.205,-0.578 0.309,-1.226 0.309,-1.943 h -8.084 c 0.032,-0.539 0.144,-1.03 0.337,-1.471 0.194,-0.44 0.449,-0.817 0.771,-1.131 0.319,-0.315 0.7,-0.557 1.148,-0.728 0.445,-0.171 0.932,-0.257 1.463,-0.257 0.793,0 1.481,0.177 2.066,0.529 0.584,0.354 1.018,0.844 1.305,1.472 h 0.71 c -0.33,-0.815 -0.85,-1.452 -1.56,-1.909 -0.71,-0.457 -1.553,-0.686 -2.521,-0.686 -0.638,0 -1.226,0.107 -1.761,0.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,980.73667,617.1652)",
    clipPath: "url(#clipPath80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m 0,0 c -0.531,0.215 -0.986,0.521 -1.366,0.918 -0.381,0.396 -0.675,0.868 -0.883,1.413 -0.211,0.545 -0.315,1.149 -0.315,1.81 0,0.661 0.104,1.264 0.315,1.81 0.208,0.545 0.502,1.014 0.883,1.405 0.38,0.391 0.835,0.697 1.366,0.917 0.527,0.221 1.112,0.331 1.75,0.331 0.993,0 1.858,-0.262 2.596,-0.785 C 5.085,7.295 5.598,6.588 5.885,5.695 H 5.239 C 4.931,6.434 4.476,7.001 3.873,7.397 3.274,7.795 2.568,7.993 1.75,7.993 1.201,7.993 0.699,7.899 0.247,7.711 -0.204,7.524 -0.595,7.262 -0.918,6.927 -1.244,6.591 -1.495,6.185 -1.671,5.711 -1.847,5.238 -1.937,4.714 -1.937,4.141 -1.937,3.568 -1.847,3.045 -1.671,2.57 -1.495,2.097 -1.244,1.689 -0.918,1.348 -0.595,1.006 -0.204,0.741 0.247,0.554 0.699,0.367 1.201,0.273 1.75,0.273 c 0.861,0 1.603,0.22 2.224,0.661 0.624,0.441 1.061,1.042 1.316,1.802 H 5.95 C 5.663,1.766 5.15,1.014 4.411,0.48 3.672,-0.055 2.786,-0.322 1.75,-0.322 1.112,-0.322 0.527,-0.214 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,993.13067,625.0668)",
    clipPath: "url(#clipPath82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m 0,0 c -0.437,0.187 -0.81,0.457 -1.119,0.81 -0.308,0.353 -0.545,0.777 -0.71,1.273 -0.165,0.495 -0.247,1.047 -0.247,1.653 v 4.711 h 0.627 V 3.785 c 0,-1.068 0.266,-1.914 0.793,-2.537 0.531,-0.622 1.258,-0.934 2.184,-0.934 0.484,0 0.925,0.089 1.323,0.265 0.395,0.176 0.735,0.424 1.015,0.743 0.283,0.32 0.502,0.703 0.663,1.15 0.158,0.445 0.237,0.938 0.237,1.479 V 8.447 H 5.397 V -0.082 H 4.849 L 4.784,1.901 C 4.486,1.207 4.045,0.67 3.461,0.29 2.876,-0.091 2.209,-0.281 1.46,-0.281 0.922,-0.281 0.434,-0.187 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1012.2667,625.12173)",
    clipPath: "url(#clipPath84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "M 0,0 V 5.074 H -1.937 V 5.67 h 1.291 c 0.266,0 0.445,0.044 0.538,0.132 0.094,0.088 0.151,0.259 0.173,0.512 L 0.097,7.719 H 0.628 V 5.67 H 3.719 V 5.074 H 0.628 V 0.016 c 0,-0.771 0.157,-1.341 0.477,-1.71 0.322,-0.37 0.839,-0.555 1.556,-0.555 H 3.852 V -2.86 H 2.643 C 0.879,-2.86 0,-1.907 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1030.1452,621.4184)",
    clipPath: "url(#clipPath86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m 783.515,372.966 h -0.628 v 8.53 h 0.628 z m -0.818,11.373 c 0.125,0.132 0.294,0.198 0.502,0.198 0.212,0 0.38,-0.066 0.506,-0.198 0.125,-0.132 0.19,-0.298 0.19,-0.496 0,-0.187 -0.065,-0.347 -0.19,-0.479 -0.126,-0.132 -0.294,-0.199 -0.506,-0.199 -0.208,0 -0.377,0.067 -0.502,0.199 -0.126,0.132 -0.19,0.292 -0.19,0.479 0,0.198 0.064,0.364 0.19,0.496",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1122.52)",
    clipPath: "url(#clipPath88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "M 0,0 3.507,-7.72 5.275,-3.769 7.011,0 H 7.689 L 3.805,-8.53 H 3.192 L -0.678,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1053.4987,613.85867)",
    clipPath: "url(#clipPath90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "M 0,0 C -0.19,0.441 -0.448,0.816 -0.767,1.124 -1.087,1.433 -1.463,1.669 -1.901,1.835 -2.335,2 -2.819,2.083 -3.346,2.083 -3.877,2.083 -4.364,1.998 -4.809,1.826 -5.254,1.656 -5.641,1.414 -5.967,1.099 -6.29,0.785 -6.552,0.411 -6.742,-0.025 -6.936,-0.46 -7.051,-0.948 -7.083,-1.487 H 0.355 C 0.312,-0.937 0.194,-0.441 0,0 m -5.125,-5.926 c -0.534,0.215 -0.99,0.521 -1.37,0.918 -0.38,0.396 -0.674,0.868 -0.885,1.413 -0.208,0.545 -0.312,1.148 -0.312,1.81 0,0.661 0.104,1.267 0.312,1.818 0.211,0.552 0.505,1.022 0.885,1.413 0.38,0.392 0.836,0.695 1.37,0.909 0.535,0.215 1.13,0.323 1.779,0.323 0.66,0 1.259,-0.113 1.793,-0.339 C -1.018,2.113 -0.559,1.791 -0.179,1.372 0.201,0.953 0.491,0.455 0.696,-0.124 0.9,-0.702 1.001,-1.35 1.001,-2.067 h -8.084 c 0.032,-0.539 0.147,-1.03 0.341,-1.471 0.19,-0.44 0.448,-0.817 0.767,-1.131 0.32,-0.315 0.703,-0.557 1.148,-0.728 0.448,-0.171 0.936,-0.257 1.463,-0.257 0.796,0 1.485,0.177 2.066,0.529 0.584,0.354 1.022,0.844 1.309,1.472 h 0.71 c -0.33,-0.815 -0.854,-1.452 -1.564,-1.909 -0.71,-0.457 -1.549,-0.686 -2.521,-0.686 -0.638,0 -1.226,0.107 -1.761,0.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1080.4815,617.1652)",
    clipPath: "url(#clipPath92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "m 0,0 c -0.714,0.292 -1.33,0.703 -1.85,1.232 -0.517,0.529 -0.922,1.16 -1.216,1.893 -0.291,0.732 -0.438,1.54 -0.438,2.421 0,0.881 0.147,1.689 0.438,2.422 0.294,0.733 0.699,1.363 1.216,1.892 0.52,0.529 1.136,0.94 1.85,1.232 0.717,0.292 1.499,0.439 2.349,0.439 0.649,0 1.266,-0.089 1.85,-0.266 C 4.784,11.09 5.315,10.836 5.795,10.505 6.276,10.175 6.692,9.775 7.043,9.307 7.395,8.838 7.671,8.312 7.872,7.728 H 7.176 C 7,8.224 6.753,8.665 6.441,9.051 6.125,9.436 5.76,9.767 5.34,10.042 4.924,10.318 4.461,10.527 3.959,10.671 3.461,10.814 2.926,10.885 2.367,10.885 1.607,10.885 0.907,10.756 0.276,10.497 -0.359,10.238 -0.907,9.875 -1.37,9.406 -1.833,8.938 -2.195,8.376 -2.453,7.72 -2.711,7.064 -2.84,6.34 -2.84,5.546 -2.84,4.753 -2.711,4.028 -2.453,3.373 -2.195,2.717 -1.833,2.154 -1.37,1.686 -0.907,1.218 -0.359,0.854 0.276,0.595 0.907,0.336 1.607,0.207 2.367,0.207 c 1.165,0 2.188,0.292 3.055,0.876 0.872,0.584 1.485,1.389 1.837,2.414 H 7.954 C 7.775,2.891 7.51,2.344 7.151,1.86 6.792,1.375 6.373,0.962 5.885,0.62 5.401,0.279 4.859,0.017 4.257,-0.165 3.658,-0.347 3.02,-0.438 2.349,-0.438 1.499,-0.438 0.717,-0.291 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1104.3083,624.91253)",
    clipPath: "url(#clipPath94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "m 0,0 c 0.187,-0.473 0.448,-0.881 0.785,-1.223 0.334,-0.341 0.736,-0.606 1.205,-0.793 0.47,-0.188 0.983,-0.282 1.546,-0.282 0.563,0 1.076,0.094 1.546,0.282 0.47,0.187 0.871,0.452 1.208,0.793 0.334,0.342 0.596,0.75 0.782,1.223 0.19,0.474 0.283,0.998 0.283,1.571 0,0.573 -0.093,1.096 -0.283,1.57 C 6.886,3.615 6.624,4.02 6.29,4.356 5.953,4.692 5.552,4.953 5.082,5.141 4.612,5.328 4.099,5.422 3.536,5.422 2.973,5.422 2.46,5.328 1.99,5.141 1.521,4.953 1.119,4.692 0.785,4.356 0.448,4.02 0.187,3.615 0,3.141 -0.19,2.667 -0.283,2.144 -0.283,1.571 -0.283,0.998 -0.19,0.474 0,0 m 1.725,-2.57 c -0.545,0.215 -1.011,0.52 -1.402,0.918 -0.395,0.396 -0.696,0.868 -0.911,1.413 -0.215,0.545 -0.323,1.148 -0.323,1.81 0,0.661 0.108,1.264 0.323,1.81 0.215,0.545 0.516,1.017 0.911,1.413 0.391,0.397 0.857,0.703 1.402,0.917 0.545,0.215 1.151,0.323 1.811,0.323 0.66,0 1.266,-0.108 1.811,-0.323 C 5.892,5.497 6.358,5.191 6.753,4.794 7.144,4.398 7.445,3.926 7.66,3.381 7.875,2.835 7.983,2.232 7.983,1.571 7.983,0.909 7.875,0.306 7.66,-0.239 7.445,-0.784 7.144,-1.256 6.753,-1.652 6.358,-2.05 5.892,-2.355 5.347,-2.57 4.802,-2.785 4.196,-2.892 3.536,-2.892 c -0.66,0 -1.266,0.107 -1.811,0.322",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1123.7456,621.6396)",
    clipPath: "url(#clipPath96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "m 0,0 c 0.452,-0.347 1.069,-0.521 1.85,-0.521 0.528,0 1.019,0.077 1.471,0.232 0.452,0.155 0.843,0.371 1.173,0.653 0.333,0.281 0.588,0.611 0.771,0.992 0.179,0.38 0.272,0.79 0.272,1.231 V 3.265 H 1.571 C 0.897,3.265 0.355,3.099 -0.057,2.769 -0.473,2.439 -0.678,1.992 -0.678,1.43 -0.678,0.824 -0.452,0.347 0,0 m -0.463,-0.421 c -0.563,0.451 -0.842,1.063 -0.842,1.835 0,0.738 0.261,1.328 0.785,1.768 C 0,3.623 0.692,3.844 1.553,3.844 H 5.537 V 4.67 C 5.537,5.045 5.469,5.387 5.329,5.695 5.193,6.003 4.996,6.268 4.745,6.488 4.49,6.709 4.185,6.879 3.834,7 3.482,7.122 3.095,7.182 2.675,7.182 1.962,7.182 1.345,7.012 0.825,6.67 0.308,6.329 -0.047,5.86 -0.233,5.265 h -0.646 c 0.212,0.782 0.632,1.396 1.259,1.843 0.628,0.446 1.388,0.67 2.281,0.67 0.516,0 0.99,-0.075 1.413,-0.224 C 4.497,7.406 4.867,7.194 5.182,6.918 5.494,6.643 5.738,6.317 5.91,5.942 6.079,5.569 6.165,5.155 6.165,4.703 V -0.95 H 5.62 L 5.569,0.769 C 5.218,0.185 4.712,-0.273 4.056,-0.603 3.4,-0.934 2.661,-1.099 1.833,-1.099 c -0.969,0 -1.736,0.226 -2.296,0.678",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1143.9719,623.96467)",
    clipPath: "url(#clipPath98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "m 0,0 c -0.527,0.215 -0.983,0.521 -1.363,0.918 -0.38,0.396 -0.674,0.868 -0.886,1.413 -0.208,0.545 -0.312,1.149 -0.312,1.81 0,0.661 0.104,1.264 0.312,1.81 0.212,0.545 0.506,1.014 0.886,1.405 0.38,0.391 0.836,0.697 1.363,0.917 0.531,0.221 1.112,0.331 1.754,0.331 0.989,0 1.854,-0.262 2.592,-0.785 C 5.085,7.295 5.598,6.588 5.885,5.695 H 5.24 C 4.931,6.434 4.476,7.001 3.877,7.397 3.278,7.795 2.568,7.993 1.754,7.993 1.201,7.993 0.699,7.899 0.247,7.711 -0.204,7.524 -0.592,7.262 -0.918,6.927 -1.241,6.591 -1.492,6.185 -1.668,5.711 -1.847,5.238 -1.933,4.714 -1.933,4.141 c 0,-0.573 0.086,-1.096 0.265,-1.571 0.176,-0.473 0.427,-0.881 0.75,-1.222 0.326,-0.342 0.714,-0.607 1.165,-0.794 0.452,-0.187 0.954,-0.281 1.507,-0.281 0.857,0 1.599,0.22 2.223,0.661 0.621,0.441 1.058,1.042 1.313,1.802 H 5.95 C 5.666,1.766 5.153,1.014 4.415,0.48 3.676,-0.055 2.79,-0.322 1.754,-0.322 1.112,-0.322 0.531,-0.214 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1164.1312,625.0668)",
    clipPath: "url(#clipPath100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "m 0,0 v -5.637 c 0.308,0.684 0.76,1.21 1.356,1.578 0.595,0.37 1.273,0.554 2.033,0.554 0.552,0 1.047,-0.093 1.488,-0.28 0.441,-0.188 0.811,-0.455 1.116,-0.803 0.301,-0.347 0.538,-0.768 0.702,-1.264 0.165,-0.496 0.248,-1.052 0.248,-1.669 v -4.712 H 6.315 v 4.679 c 0,1.079 -0.265,1.923 -0.792,2.529 -0.531,0.606 -1.263,0.909 -2.199,0.909 -0.487,0 -0.932,-0.085 -1.341,-0.256 C 1.574,-4.544 1.227,-4.786 0.932,-5.1 0.642,-5.414 0.412,-5.794 0.247,-6.24 0.082,-6.687 0,-7.18 0,-7.72 v -4.513 H -0.628 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1181.6033,608.9216)",
    clipPath: "url(#clipPath102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "m 900.96,372.966 h -0.628 v 8.53 h 0.628 z m -0.818,11.373 c 0.126,0.132 0.294,0.198 0.502,0.198 0.212,0 0.38,-0.066 0.506,-0.198 0.125,-0.132 0.19,-0.298 0.19,-0.496 0,-0.187 -0.065,-0.347 -0.19,-0.479 -0.126,-0.132 -0.294,-0.199 -0.506,-0.199 -0.208,0 -0.376,0.067 -0.502,0.199 -0.125,0.132 -0.19,0.292 -0.19,0.479 0,0.198 0.065,0.364 0.19,0.496",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1122.52)",
    clipPath: "url(#clipPath104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "m 0,0 0.05,-2 c 0.298,0.704 0.75,1.248 1.349,1.628 0.598,0.38 1.28,0.57 2.04,0.57 0.552,0 1.047,-0.093 1.488,-0.28 0.442,-0.188 0.818,-0.459 1.134,-0.811 0.312,-0.352 0.552,-0.776 0.717,-1.273 0.165,-0.496 0.247,-1.052 0.247,-1.669 V -8.53 H 6.398 v 4.661 c 0,1.07 -0.273,1.913 -0.818,2.53 -0.545,0.617 -1.28,0.926 -2.205,0.926 -0.484,0 -0.929,-0.089 -1.331,-0.265 C 1.642,-0.854 1.295,-1.102 1.001,-1.422 0.71,-1.741 0.484,-2.121 0.323,-2.562 0.165,-3.003 0.086,-3.494 0.086,-4.034 V -8.53 H -0.545 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1211.8328,613.85867)",
    clipPath: "url(#clipPath106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "m 0,0 c 0.183,-0.457 0.437,-0.849 0.76,-1.174 0.327,-0.325 0.718,-0.579 1.177,-0.761 0.455,-0.181 0.954,-0.272 1.495,-0.272 0.549,0 1.051,0.091 1.503,0.272 0.452,0.182 0.842,0.436 1.165,0.761 0.327,0.325 0.581,0.713 0.76,1.165 C 7.043,0.443 7.133,0.945 7.133,1.495 7.133,2.047 7.043,2.548 6.86,3 6.681,3.452 6.427,3.837 6.1,4.157 5.777,4.477 5.387,4.728 4.935,4.91 4.483,5.091 3.981,5.182 3.432,5.182 2.88,5.182 2.378,5.091 1.926,4.91 1.474,4.728 1.087,4.477 0.76,4.157 0.437,3.837 0.183,3.452 0,3 -0.179,2.548 -0.273,2.047 -0.273,1.495 -0.273,0.956 -0.179,0.457 0,0 m 2.152,-6.249 c -0.449,0.127 -0.843,0.308 -1.184,0.546 -0.34,0.237 -0.624,0.524 -0.85,0.859 -0.226,0.336 -0.383,0.708 -0.473,1.116 h 0.628 c 0.078,-0.319 0.215,-0.611 0.405,-0.876 0.193,-0.264 0.437,-0.488 0.728,-0.67 0.294,-0.182 0.62,-0.321 0.982,-0.421 0.366,-0.099 0.761,-0.149 1.191,-0.149 0.531,0 1.008,0.075 1.438,0.224 0.43,0.148 0.796,0.36 1.101,0.636 0.301,0.275 0.538,0.609 0.71,1 0.172,0.392 0.255,0.824 0.255,1.298 v 1.917 C 6.731,-1.408 6.236,-1.91 5.598,-2.273 4.956,-2.637 4.221,-2.819 3.382,-2.819 c -0.628,0 -1.209,0.108 -1.736,0.323 -0.531,0.214 -0.983,0.512 -1.356,0.892 -0.372,0.38 -0.667,0.835 -0.875,1.364 -0.211,0.529 -0.315,1.108 -0.315,1.735 0,0.629 0.104,1.207 0.315,1.736 0.208,0.529 0.503,0.984 0.875,1.364 0.373,0.38 0.825,0.675 1.356,0.885 0.527,0.209 1.108,0.314 1.736,0.314 0.85,0 1.596,-0.185 2.241,-0.555 C 6.265,4.871 6.764,4.361 7.119,3.711 l 0.05,1.884 h 0.545 v -8.298 c 0,-0.551 -0.1,-1.055 -0.298,-1.513 -0.201,-0.457 -0.48,-0.85 -0.842,-1.181 -0.366,-0.331 -0.8,-0.587 -1.309,-0.77 -0.506,-0.181 -1.069,-0.272 -1.686,-0.272 -0.506,0 -0.983,0.064 -1.427,0.19",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1230.9259,621.3192)",
    clipPath: "url(#clipPath108)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontalWhite);
export default __webpack_public_path__ + "static/media/logo-horizontal-white.39b93099132a4f1fb7207c361ab17fc0.svg";
export { ForwardRef as ReactComponent };